/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { LoadingSpinner } from '@blend/enterprise-components';

export const styles = StyleSheet.create({
  centeredContainer: {
    alignItems: 'center',
    display: 'flex',
    height: '100%',
    justifyContent: 'center',
    width: '100%',
  },
});

export const CenteredLoadingSpinner = () => (
  <div className={css(styles.centeredContainer)}>
    <LoadingSpinner size="lg" theme="secondary" />
  </div>
);
